import { Component, Input, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { IAlbum, Patient } from 'src/app/core/models/patient/patient';
import { PatientDrivingLicense } from 'src/app/core/models/patient/patientDrivingLicense';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { Lightbox } from 'ngx-lightbox';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profile-driver-license',
  templateUrl: './profile-driver-license.component.html',
  styleUrls: ['./profile-driver-license.component.scss'],
})
export class ProfileDriverLicenseComponent implements OnInit {

  @Input() isParams = false;
  @Input() patientProfile: Patient;
  @Output() patientProfileChange = new EventEmitter<Patient>();
  @Output() toggleEditEvent = new EventEmitter();
  driverLicenseDetails: PatientDrivingLicense;
  imgAlbum: IAlbum[];

  constructor(
    private formBuilder: FormBuilder,
    private patientService: PatientService,
    private lightbox: Lightbox,
    private datePipe: DatePipe
  ) { }

  licenseForm = this.formBuilder.group({
    dlNumber: [''],
    class: [''],
    expirationDate: ['']
  });

  slideConfig = {
    'slidesToShow': 1,
    'slidesToScroll': 1,
    'infinite': false,
    'dots': false,
    'variableWidth': false,
    'autoplay': false,
    'arrows': true
  };


  ngOnInit() {
  }

  toggleEdit() {
    this.toggleEditEvent.emit();
  }

  openLightbox(url): void {
    const album: IAlbum[] = [{ src: url, thumb: url }]
    this.lightbox.open(album, 0);
  }

  onFileSelected() { }
}
